import { useQuery } from '@tanstack/react-query';

import { getTaskSiblings } from '@/lib/api/generated/api';
import { expectStatus } from '@/lib/api/client';
import type { SiblingsResponse } from '@/lib/api/generated/model';
import { taskRelationsKeys } from '../queryKeys';

/** Fetched only once a group's "Show siblings" toggle is switched on. */
export function useRelatedTaskSiblings(
  workspaceId: string,
  taskId: string,
  workflowId: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: taskRelationsKeys.siblings(workspaceId, taskId, workflowId),
    queryFn: async (): Promise<SiblingsResponse> =>
      expectStatus(
        await getTaskSiblings(workspaceId, taskId, {
          workflow_id: workflowId,
        }),
        200,
        'The siblings could not be loaded.',
      ),
    enabled,
  });
}
